import { getAdminBaseUrl } from '../utils/admin-url';

// GENERAL PATHS
export const HOME_PATH = '';

export const GENERAL_CALCULATOR_PATH = 'calculadora';
export const GENERAL_DETAILED_ANALYSIS_PATH = 'analise-detalhada/:simulationId';
export const GENERAL_CONTRACT_PATH = 'contrato';
export const GENERAL_SIMULATION_PATH = 'proposta/:simulationId';
export const GENERAL_SIMPLIFIED_PROPOSAL_PATH = 'proposta-simplificada/:simulationId';
export const HISTORY_PATH = 'historico';
export const SIMULATIONS_BY_LEAD_PATH = 'simulacoes-por-lead';
export const LEAD_PROPOSALS_PATH = 'lead/:leadId/propostas';
export const GENERAL_LIST_PATH = 'lista';

// SIMULATOR PATHS
export const SCENARIOS_SIMULATOR_PATH = '/simulador-de-cenarios';
export const GD_SIMULATOR_PATH = '/geracao-distribuida';
export const CLARKE_MANAGEMENT_PATH = '/clarke-gestao';
export const CLARKE_RETAIL_PATH = '/clarke-varejo';
export const CONTRACTED_DEMAND_PATH = '/demanda-contratada';

// GD PROPOSAL PATHS
export const GD_PROPOSAL_FORM_PATH = 'proposta-form';

// OTHER PLATFORMS PATHS
export const ADMIN_PATH = `${getAdminBaseUrl()}/`;
